import { useState } from "react";
import "./styles.scss";

export const QuestionMark = (props) => {
    const [disclaimerStatus, setDisclaimerStatus] = useState(false);

    const DISCLAIMER = props.disclaimer ? props.disclaimer : "";

    const toggleDisclaimer = () => {
        setDisclaimerStatus(!disclaimerStatus);
    };

    return (
        <div className="disclaimer-container">
            <div
                className="disclaimer"
                data-status={disclaimerStatus}
                id="disclaimer-info"
            >
                {DISCLAIMER}
            </div>
            <button
                className="question-mark sclt-questionmark"
                aria-describedby="disclaimer-info"
                aria-label="More Information"
                onClick={toggleDisclaimer}
            >
                {disclaimerStatus ? "X" : "?"}
            </button>
        </div>
    );
};
export default QuestionMark;
